import React from "react"
import { connect } from "react-redux"
import { push } from "connected-react-router"
import Ajax from "superagent"
import Cookies from "js-cookie"

import ReactMarkdown from "react-markdown"

import Characteristics from "./components/Characteristics"
import CoolPage from "../components/CoolPage"
import rooms from "./rooms"
import RoomModal from './components/RoomModal'

import "./Room.less"


class Room extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const roomKey = this.props.match.params.key
    const room = rooms.find(r => r.key == roomKey)

    return (
      <CoolPage 
        barColor={[238, 237, 235]} 
        className="roomPage tepaPage" 
        title={room.title}
        footerButton
        onFooterClick={() => this.setState({showModal: true})}
        footerLabel="改变房间"
      >
        <div className="roomPageContent">
          <img
            className="principal-image"
            src={room.imagenurl}
          />

          <div className="contenido">
            <div className="priceTag">+150€</div>

            <h1>{room.title}</h1>
            <p className="subtitle">{room.subtitle}</p>

            {/* <ReactMarkdown className="description" source={room.description} /> */}

            <h2> 酒店特点 </h2>
            <Characteristics list={room.characteristics} />
            
            <h2>付费服务</h2>
            <ul>
              {
                room.services.map(service => (
                  <li key={service}>{service}</li>
                ))
              }
            </ul>
          </div>
        </div>

        {this.state.showModal && (
          <RoomModal 
            room = {room}
            onClose={() => this.setState({showModal: false})}
            onSuccess={() => {
              Ajax.post("/addreservation")
                .send({
                  ...this.props.userData,
                  type: "teparoom",
                  upgradeRequested: room.key,
                  roomNumber: Cookies.get("tepaRoom")
                })
                .then()
            }}
          /> 
        )}
      </CoolPage>

    )
  }
}

const mapStateToProps = (_state, _ownProps) => ({ })

const mapDispatchToProps = dispatch => {
  const goto = url => dispatch(push(url))
  return {
    goto,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Room)



// WEBPACK FOOTER //
// ./src/app/catalogo/hotels/Room.jsx